import { ADD } from "@crispico/foundation-react";
import { AppMetaTempGlobals } from "@crispico/foundation-react/AppMetaTempGlobals";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { IGanttActionParam, IGanttActionParamForRun } from "@crispico/react-timeline-10000";
import { AbstractAction } from "components/ContextMenuRegistry";
import moment from "moment-timezone";

export class CreateTaskAction extends AbstractAction {

    icon = "list alternate outline";
    label = _msg("CreateTaskAction.label");

    protected getSearchParams(id: string | number, startTime?: number | object): string {
        const entity = this.props.getEntityAt(id);
        if (!entity) {
            return '';
        }
        const params = new URLSearchParams();
        entityDescriptors["Flight"].toMiniString(entity);
        params.set(`taskGroup`, JSON.stringify(entity));
        if (startTime) {
            params.set(`startTime`, moment(startTime).toISOString());
        }
        return params.toString();
    }

    private getActionTarget(param: IGanttActionParam): { key: string | number; entityName: string } | null {
        let key: string | number;
        let entityName: string;

        if (param.selection.length === 1) {
            key = param.selection[0];
            entityName = this.getEntityName(key);
        } else if (param.selection.length === 0) {
            if (param.row === undefined || !this.props.getEntityAt(param.row)) {
                return null;
            }
            key = param.row;
            entityName = this.getEntityName(this.props.getEntityUid(key));
        } else {
            return null;
        }
        return { key, entityName };
    }

    isVisible(param: IGanttActionParam) {
        const target = this.getActionTarget(param);
        if (!target) {
            return false;
        }

        return target.entityName === "Flight";
    }

    async run(param: IGanttActionParamForRun) {
        const target = this.getActionTarget(param);
        if (!target) {
            // This case should ideally not be reached if isVisible is respected,
            // but it's a good safeguard.
            return;
        }
        const { key } = target;

        const searchParams = this.getSearchParams(key, param.time);
        AppMetaTempGlobals.history.push(entityDescriptors["Task"].getEntityEditorUrl(ADD) + "/edit?" + searchParams);
    }
}
